/*
 * newsletter-status.js — öffnet das Newsletter-Status-Popup (sections/newsletter-status.liquid).
 *
 * Trigger (Query-Params — in Liquid nicht lesbar, daher client-seitig):
 *   ?newsletter=confirmed     ← Redirect von /account/subscribe (layout/theme.liquid)
 *   ?newsletter=unsubscribed  ← Redirect von /account/unsubscribe
 *   ?customer_posted=true     ← Shopify-Rückkehr nach dem Wiederanmelde-Formular im Popup;
 *                               zählt nur mit gesetztem sessionStorage-Flag (sonst stammt der
 *                               Post von einem anderen Newsletter-Formular der Seite).
 *
 * Nach dem Auswerten werden die Trigger-Params per history.replaceState entfernt, damit
 * Reload/Teilen der URL das Popup nicht erneut öffnet. Öffnen/Fokus/Escape via overlay.js.
 */
(function () {
  'use strict';

  var RESUB_KEY = 'hm-nl-resub';
  var panel = document.getElementById('newsletter-status');
  if (!panel || !('URLSearchParams' in window)) return;

  // Wiederanmelde-Formular im Popup: Flag setzen, damit die Rückkehr zuordenbar ist.
  var form = panel.querySelector('form');
  if (form) {
    form.addEventListener('submit', function () {
      try { sessionStorage.setItem(RESUB_KEY, '1'); } catch (e) {}
    });
  }

  var params = new URLSearchParams(window.location.search);
  var nl = params.get('newsletter');
  var posted = params.get('customer_posted') === 'true';

  // Wiederanmelde-Flag lesen und SOFORT verwerfen (One-Shot): Es gilt nur für die
  // unmittelbar auf den Popup-Submit folgende Theme-Seite — Erfolg (?customer_posted=true)
  // ODER Fehler-Rerender (form.errors, ohne Param). So kann ein liegengebliebenes Flag
  // (Captcha-Abbruch, Tab-Wechsel) keine spätere Anmeldung über ein anderes
  // Newsletter-Formular als „resubscribed" kapern. Shopifys /challenge-Zwischenseite
  // rendert ohne Theme-Layout und konsumiert das Flag nicht.
  var resub = false;
  try {
    resub = !!sessionStorage.getItem(RESUB_KEY);
    if (resub) sessionStorage.removeItem(RESUB_KEY);
  } catch (e) {}

  var state = null;
  if (nl === 'confirmed' || nl === 'unsubscribed') {
    state = nl;
  } else if (posted && resub) {
    state = 'resubscribed';
  } else if (resub && panel.querySelector('.hm-nlform__error')) {
    // Popup-Submit kam mit Server-Fehler zurück: Popup im Abmelde-Zustand wieder
    // öffnen, damit die Fehlermeldung (role="alert" im Formular) sichtbar wird.
    state = 'unsubscribed';
  }
  if (!state) return;

  // Trigger-Params aus der URL entfernen (Rest der Query bleibt erhalten).
  params.delete('newsletter');
  params.delete('customer_posted');
  var qs = params.toString();
  try {
    history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : '') + window.location.hash);
  } catch (e) {}

  // Passenden Zustand einblenden, die anderen verbergen.
  panel.querySelectorAll('[data-nl-state]').forEach(function (el) {
    el.hidden = el.getAttribute('data-nl-state') !== state;
  });

  var H = window.Homedia;
  if (!H || !H.overlay) return; // overlay.js lädt vor diesem Script (defer-Reihenfolge)
  H.overlay.open(panel, { labelledby: 'hm-nls-title-' + state });

  try {
    if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
      Shopify.analytics.publish('homedia:newsletter_' + state, {});
    }
  } catch (e) {}
})();
